import { useTranslations } from "next-intl";
import Container from "src/sections/container/Container";
import Layout from "src/sections/layout/Layout";
import useCountryData from "src/hooks/useCountryData";
import { GetStaticProps } from "next";
import { Collection } from "src/types/storefront";
import { Locale } from "src/types/localization/Locale";
import getCountryCodeFromLocale from "src/helpers/localization-helpers/getCountryCodeFromLocale";
import getCollectionById from "src/apis/storefront-latest-version/collections/getCollectionById";
import countries from "src/config/countries/countries";
import getTranslations from "src/helpers/localization-helpers/getTranslations";

interface LegalProps {}

const Legal = ({}: LegalProps) => {
  const t = useTranslations("Legal");
  const countryData = useCountryData();

  return (
    <Layout pageTitle="Legal" showStickyFooterNavigationButton={true} description="Shemsi legal information">
      <Container>
        <section className="space-y-8 leading-7">
          <h2 className="title-1 uppercase">{t("general_conditions")}</h2>

          <div className="space-y-8">
            {/* Preamble */}
            <div className="space-y-4">
              <h3 className="title-2 uppercase">{t("preamble")}</h3>
              <p className="max-w-4xl">{t("present_general_conditions")}</p>
              <p className="max-w-4xl">{t("any_order_placed")}</p>
            </div>

            {/* Legal Information */}
            <div className="space-y-4">
              <h3 className="title-2 uppercase">{t("legal_information")}</h3>
              <p className="max-w-4xl">{t("shm_egypt_limited_liability_company")}</p>
              <p className="max-w-4xl">
                {t("email")}
                <a className="underline" href="mailto:contact@myshemsi.com">
                  {t("contact_mail")}
                </a>
              </p>
            </div>

            {/* Hosting Provider: */}
            <div className="space-y-4">
              <h3 className="title-2 uppercase">{t("hosting_provider")}</h3>
              <p className="max-w-4xl">{t("hosted_by")}</p>
            </div>
          </div>

          <hr className="border-gray-500" />

          {/* 1. Products */}
          <div className="space-y-4">
            <h3 className="title-2 uppercase">{t("products")}</h3>
            <p className="max-w-4xl">{t("products_offered_for_sale")}</p>
            <p className="max-w-4xl">{t("photos_of_products")}</p>
            <h4 className="title-3">{t("product_availability")}</h4>
            <p className="max-w-4xl">{t("accepts_orders")}</p>
          </div>

          <hr className="border-gray-500" />

          {/* 2. Order */}
          <div className="space-y-4">
            <h3 className="title-2 uppercase">{t("order")}</h3>
            <h4 className="title-3">{t("the_client")}</h4>
            <p className="max-w-4xl">
              {t("sale_on_website")}
              <a className="underline" href="https://myshemsi.com">
                {t("myshemsi")}
              </a>
              {t("to_consumers")}
            </p>
            <p className="max-w-4xl">{t("customer_agrees")}</p>
            <p className="max-w-4xl">{t("customer_responsible")}</p>
            <p className="max-w-4xl">{t("shm_may_delete_account")}</p>
            <h4 className="title-3">{t("order_registration")}</h4>
            <p className="max-w-4xl">{t("any_customer_wishes_to_place_order")}</p>
            <p className="max-w-4xl">{t("in_order_to_validate_order")}</p>
            <p className="max-w-4xl">{t("order_will_be_confirmed")}</p>
          </div>

          <hr className="border-gray-500" />

          {/* 3. Prices */}
          <div className="space-y-4">
            <h3 className="title-2 uppercase">{t("prices_and_payment_terms")}</h3>
            <h4 className="title-3">{t("prices")}</h4>
            {countryData && <p className="max-w-4xl">{t("prices_of_products", { currency: countryData.currency })}</p>}
            <p className="max-w-4xl">{t("prices_can_be_modified")}</p>
            <h4 className="title-3">{t("method_of_payment")}</h4>
            <p className="max-w-4xl">{t("the_payment_of_purchase")}</p>
          </div>
        </section>
      </Container>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps<{
  // storeMetadata: Collection;
  // newPriceCollection: Collection | null;
}> = async ({ locale }) => {
  if (!locale) {
    throw new Error(`locale is not passed to getStaticProps`);
  }

  if (!(locale in Locale)) locale = Locale["ar-EG"];

  // const countryCode = getCountryCodeFromLocale(locale as Locale);
  // const countryData = countries[countryCode];

  // const storeMetadata = await getCollectionById(
  //   countryCode,
  //   countryData.collections.COLLECTION_ALL_ACTIVE_PRODUCTS.id,
  //   true
  // );

  // let newPriceCollection: Collection | null = null;
  // if (countryData.deploymentConfig.COLLECTION_NEW_PRICES) {
  //   newPriceCollection = await getCollectionById(
  //     countryData.code,
  //     countryData.deploymentConfig.COLLECTION_NEW_PRICES,
  //     true
  //   );
  // }

  const translations = getTranslations(locale);

  return {
    props: {
      // storeMetadata: storeMetadata,
      // newPriceCollection,
      translations,
    },
  };
};

export default Legal;
